import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-5 col-sm-6 text-right" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = {
  key: 0,
  class: "table table-striped"
}
const _hoisted_8 = { scope: "row" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }

import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import { useWorkspacesByOrganizationQueryV1 } from '@Organizations/Workspaces/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageWorkspacesPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    const {
        runWorkspacesByOrganizationQueryV1,
        modelWorkspacesByOrganizationQueryV1: model
    } = useWorkspacesByOrganizationQueryV1(tid)


    const workspaces = computed(() => model.value?.Workspaces ?? [])

    onMounted(() =>
    {
        document.title = 'Workspaces'
        runWorkspacesByOrganizationQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-7" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Workspaces")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: `/#/admin/organizations/workspaces/create/${tid.value}`,
            role: "button",
            class: "btn btn-success text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Add workspace ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      (workspaces.value.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  style: {"border-top":"none"}
                }, "#"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"border-top":"none"}
                }, "Name"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"border-top":"none"}
                }, "Description"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"border-top":"none"}
                })
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (w, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: w.WorkspaceId
                }, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(i+1), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: `/#/admin/organizations/workspaces/manage/${w.WorkspaceId}`
                    }, _toDisplayString(w.Name), 9 /* TEXT, PROPS */, _hoisted_9)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(w.Description), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: w.StartupUrl ? `/#${w.StartupUrl}${w.WorkspaceId}` : `/#/projects/${w.WorkspaceId}`,
                      target: "_blank"
                    }, "Open", 8 /* PROPS */, _hoisted_10)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : (_openBlock(), _createElementBlock("h4", _hoisted_11, "No workspaces"))
    ])
  ]))
}
}

})